import { formatCurrency, withCommas } from "@/utils/number";

export type MetricKey =
  | "avg_damage"
  | "avg_damage_mtd"
  | "avg_failure"
  | "avg_failure_mtd"
  | "productivity_loss"
  | "sum_damage"
  | "ttip"
  | "cav"
  | "total_market_value"
  | "average_market_value"
  | "total_replacement_cost"
  | "average_replacement_cost";

export const PERCENT_METRICS: MetricKey[] = [
  "avg_damage",
  "avg_failure",
  "avg_damage_mtd",
  "avg_failure_mtd",
  "productivity_loss",
  "sum_damage",
];

export const formatYAxisTickToPercent = (value: number, decimalPlaces: number | undefined = undefined): string => {
  let places: number;

  if (decimalPlaces !== undefined) {
    places = decimalPlaces;
  } else if (value >= 20 || value === 0) {
    places = 0;
  } else if (value >= 10) {
    places = 1;
  } else {
    places = 2;
  }

  return `${value.toFixed(places)}%`;
};

export const formatYAxisTick = (
  metric: MetricKey,
  value: number,
  decimalPlaces: number | undefined = undefined,
  compact: boolean = true
): string => {
  if (PERCENT_METRICS.includes(metric)) return formatYAxisTickToPercent(value, decimalPlaces);
  return formatCurrency(value, compact);
};

export const formatMetricValue = (unit: "%" | "$", value: number, decimalPlaces: number = 2): string =>
  unit === "%"
    ? `${value.toFixed(decimalPlaces)}%`
    : `${value < 0 ? "-$" : "$"}${withCommas(Math.abs(value).toFixed(decimalPlaces))}`;
